import { toastFail } from './toastFail'
export const checkFileType = async files => {
  const getSignature = () => {
    return new Promise(resolve => {
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(files)
      fileReader.addEventListener('load', e => {
        const arrayBuffer = e.target.result
        const dataView = new DataView(arrayBuffer)
        // JPEG: "FF D8 FF" or the hexadecimal equivalent "FF D8 FF"
        // PNG: "89 50 4E 47 0D 0A 1A 0A" or the hexadecimal equivalent "89 50 4E 47 0D 0A 1A 0A"
        // GIF: "47 49 46 38" or the hexadecimal equivalent "47 49 46 38"
        // BMP: "42 4D" or the hexadecimal equivalent "42 4D"
        // TIFF: "49 49 2A 00" or the hexadecimal equivalent "49 49 2A 00" or "4D 4D 00 2A" or the hexadecimal equivalent "4D 4D 00 2A"
        // PDF: "%PDF-"
        // DOC: "D0 CF 11 E0 A1 B1 1A E1" or the hexadecimal equivalent "D0 CF 11 E0 A1 B1 1A E1"
        // DOCX: "504B 0304" or the hexadecimal equivalent "50 4B 03 04"
        // XLS: "D0 CF 11 E0 A1 B1 1A E1" or the hexadecimal equivalent "D0 CF 11 E0 A1 B1 1A E1"
        // XLSX: "504B 0304" or the hexadecimal equivalent "50 4B 03 04"
        // PPT: "D0 CF 11 E0 A1 B1 1A E1" or the hexadecimal equivalent "D0 CF 11 E0 A1 B1 1A E1"
        // PPTX: "504B 0304" or the hexadecimal equivalent "50 4B 03 04"
        // TXT: ASCII encoded file
        if (files.type === 'text/plain') {
          const uint8Array = new Uint8Array(arrayBuffer)
          const unicodeString = new TextDecoder().decode(uint8Array)
          console.log(uint8Array, 'uint8Array')
          console.log(unicodeString)
          let isASCIIAllow = true
          // for (let i = 0; i < unicodeString.length; i++) {
          //   const charCode = unicodeString.charCodeAt(i)
          //   console.log('charCode', charCode)
          //   if (
          //     (charCode < 0 || charCode > 127) &&
          //     (charCode < 0x0e00 || charCode > 0x0e7f)
          //   ) {
          //     isASCIIAllow = false
          //     break
          //   }
          // }

          if (isASCIIAllow) {
            resolve(true)
          } else {
            resolve(false)
          }
        } else {
          resolve(dataView.getUint32(0, false))
        }
      })
    })
  }

  const signature = await getSignature()
  console.log(signature, 'signature')

  const checkTypeJPG = files => {
    const splitNameAndType = files.name.split('.')
    const type = splitNameAndType[splitNameAndType.length - 1]
    return type.includes('jpg')
  }

  if (
    files.type === 'image/jpeg' &&
    checkTypeJPG(files) &&
    signature === 0xffd8ffe0
  ) {
    return true
  } else if (files.type === 'image/png' && signature === 0x89504e47) {
    return true
  } else if (files.type === 'image/gif' && signature === 0x47494638) {
    return true
  } else if (
    files.type === 'image/bmp' &&
    (signature === 1112377979 || signature === 1112356477)
  ) {
    return true
  } else if (files.type === 'image/tif' && signature === 0x49492a00) {
    return true
  } else if (files.type === 'image/tiff' && signature === 0x49492a00) {
    return true
  } else if (files.type === 'application/pdf' && signature === 626017350) {
    return true
  } else if (files.type === 'application/msword' && signature === 0xd0cf11e0) {
    return true
  } else if (
    files.type ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
    signature === 1347093252
  ) {
    return true
  } else if (
    files.type === 'application/vnd.ms-excel' &&
    signature === 0xd0cf11e0
  ) {
    return true
  } else if (
    files.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    [1970168933, 1347093252].includes(signature)
  ) {
    return true
  } else if (
    files.type === 'application/vnd.ms-powerpoint' &&
    signature === 0xd0cf11e0
  ) {
    return true
  } else if (
    files.type ===
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' &&
    signature === 1347093252
  ) {
    return true
  } else if (files.type === 'text/plain' && signature) {
    return true
  } else {
    toastFail(
      'Wrong file format. File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, xls, xlsx, ppt, pptx, txt'
    )
    return false
  }
}
